import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
//redux
import {
  listProducts,
  unloadProducts,
} from '../../modules/productModule/products';

//@mui
import { useGridApiRef } from '@mui/x-data-grid-pro';

import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import ProductSearchContainer from './ProductSearchContainer';
import ProductUploadModalContainer from './ProductUploadModalContainer';
import ProductList from '../../components/productmng/ProductList';
import * as productApi from '../../lib/api/product';
import { downloadFile } from '../../utils/fileCodeUtils';

const ProductListContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();

  const { products, error, loading } = useSelector(
    ({ productModule, loading }) => ({
      products: productModule.products.products,
      error: productModule.products.error,
      loading: loading['product/LIST_PRODUCTS'],
    }),
  );

  const apiRef = useGridApiRef();
  //const getUnfilteredRows = ({ apiRef }) => gridSortedRowIdsSelector(apiRef);

  const handleDownExcel = async (searchData) => {
    try {
      const blob = await productApi.downloadExcel(searchData);
      const filename = blob.headers['filename'];

      downloadFile(blob, decodeURIComponent(filename), 'xlsx');
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  // const handleDownExcel = () => {
  //   apiRef.current.exportDataAsCsv({
  //     getRowsToExport: getUnfilteredRows,
  //     fileName: '제품 리스트',
  //     utf8WithBom: true,
  //     fields: [
  //       'productUuid',
  //       'partnerNm', //제조사
  //       'productLine', //제품군
  //       'category', //분류
  //       'productNm', //제품명
  //       'price', //매입가격
  //       'priceConsume', //소비자 가격

  //       'useYn',
  //       'cngNm',
  //       'cngDt',
  //     ],
  //     //allColumns: true
  //   });
  // };

  //upload
  const [uploadVisible, setUploadVisible] = useState(false);
  const openUploadModel = () => {
    setUploadVisible(true);
  };
  const closeUploadModal = () => {
    setUploadVisible(false);
  };

  // datagrid
  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'productUuid',
        headerName: 'UUID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'partnerNm',
        headerName: '제조사',
        minWidth: 200,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'productLine',
        headerName: '제품군',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'category',
        headerName: '아이템명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productNm',
        headerName: '제품명',
        minWidth: 300,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'price',
        headerName: '매입가격',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
        editable: false,
      },
      {
        field: 'priceConsume',
        headerName: '소비자 가격',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
        editable: false,
      },

      {
        field: 'useYn',
        headerName: '사용유무',
        minWidth: 80,
        flex: 1,
        type: 'boolean',
        editable: false,
      },

      {
        field: 'cngNm',
        headerName: '수정자',
        minWidth: 80,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'cngDt',
        headerName: '수정일',
        minWidth: 200,
        flex: 1,
        type: 'dateTime',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    navigate(`/productmng/${param.id}`);
  };

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    dispatch(listProducts());

    return () => {
      dispatch(unloadProducts());
    };
  }, []);

  return (
    <>
      <BreadcrumbsContainer
        title="거래처&제품 관리/제품&상품 관리"
        icon="partner"
      />
      <ProductSearchContainer
        downloadExl={handleDownExcel}
        uploadExl={openUploadModel}
      />
      <ProductList
        apiRef={apiRef}
        columns={columns}
        products={products}
        error={error}
        loading={loading}
        handleRowClick={handleRowClick}
      />
      <ProductUploadModalContainer
        title="제품 엑셀 업로드"
        open={uploadVisible}
        handleClose={closeUploadModal}
      />
    </>
  );
};

export default ProductListContainer;
